            /**
         * Created with JetBrains WebStorm.
         * User: sebastienbeaujard
         * Date: 28/07/13
         * Time: 09:22
         * To change this template use File | Settings | File Templates.
         */

angular.module('FlexyBeautyApp.controllers').
    controller('PosFormCtrl', ["$scope", "TaxMode", "LanguageManager", function ($scope, TaxMode, LanguageManager)
    {

        $scope.onCustomerInputKeyDown = function(event)
        {
            var keyCode = event.which;
            //if key delete detected : clear customer
            if (keyCode==8 || keyCode==46)
            {
                if ($scope.dd.view.posView.edited.saleView)
                    $scope.dd.view.posView.edited.saleView.customerView = null;

            }
        };

        $scope.setCurrentCategory  = function(categoryView)
        {
            $scope.dd.view.cCategoryView = categoryView;
        };
        $scope.setCurrentProductCategory  = function(categoryView)
        {
            $scope.dd.view.cProductCategoryView = categoryView;
        };

        $scope.openNewSale = function() {
            $scope.dd.view.display.menuMobile = false;
            $scope.dd.view.posView.sideMenu = false;
            $scope.dd.view.display.posSubMode = 1;
            $scope.dd.view.posView.loadNewSell();
        }

        $scope.openEstimation = function() {
            $scope.dd.view.display.menuMobile = false;
            $scope.dd.view.posView.sideMenu = false;
            $scope.dd.view.display.posSubMode = 1;
            $scope.dd.view.posView.loadEstimationSell();
        }

        $scope.openConfiguration = function() {
            $scope.dd.view.display.menuMobile=false;
            $scope.dd.view.posView.sideMenu=false;
            $scope.dd.view.display.posSubMode=7;
            $scope.dd.view.posView.openConfigWindow()
        }

        $scope.taxModeList = TaxMode;

        /*var $table = $('#table-export-details'),
            $bodyCells = $table.find('tbody tr:first').children(),
            colWidth;

        // Get the tbody columns width array
        colWidth = $bodyCells.map(function () {
            return $(this).width();
        }).get();

        // Set the width of thead columns
        $table.find('thead tr').children().each(function (i, v) {
            $(v).width(colWidth[i]);
        });*/
}]);




// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/PosFormCtrl.js